import React from "react";
import { observer } from "mobx-react-lite";
import { useGlobalStore } from "@/store/hooks";

import useAutoOpenBeginnerGuideModal from "@/components/Modal/BeginnerGuideModal/useAutoOpenBeginnerGuideModal";
import { Button, Col, Row } from "antd";
import ShopInfoCard from "./scenes/components/ShopInfoCard";
import PlatformCard from "./scenes/components/PlatformCard";
import CustomerServices from "./scenes/components/CustomerServices";
import FeaturesCard from "./scenes/components/FeaturesCard";
import VideoCourseCard from "./scenes/components/VideoCourseCard";
import SupplierInfo from "./scenes/components/SupplierInfo";
import EwaybillAccountQuantityCard from "./scenes/components/EwaybillAccountQuantityCard";
import SurveyModal from "./components/SurveyModal";

interface HomeProps {}

/**
 * 首页
 */
const Home: React.FC<HomeProps> = observer(() => {
    useAutoOpenBeginnerGuideModal();

    const globalStore = useGlobalStore();

    /** 参数构建成功且自定义组件成功加载才显示组件 */
    const showJdNps = !!(globalStore.JdSDKStore.npsCustomParams && window.customElements.get("shop-common-components"));

    return (
        <div>
            <div style={{ padding: 20 }}>
                <Row gutter={30}>
                    <Col span={15}>
                        <ShopInfoCard />

                        <PlatformCard />
                    </Col>
                    <Col span={9}>
                        <div
                            style={{
                                background: "#eff1fb",
                                height: "50px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <img
                                src="https://img.alicdn.com/imgextra/i1/54458674/O1CN01Ek2RHg2DwkbFZNl5m_!!54458674.png"
                                alt="问卷.png"
                                width="40px"
                                height="40px"
                            />
                            <span className="fb fs16">发货易邀您来评价软件!</span>
                            <Button
                                type="primary"
                                size="small"
                                className="ml5"
                                style={{ background: "#4e6aff" }}
                                onClick={() => {
                                    globalStore.modalStore.openModal(SurveyModal);
                                }}
                            >
                                去填写
                            </Button>
                        </div>

                        {globalStore.companyRoleStore.isSupplier ? <SupplierInfo /> : null}

                        <EwaybillAccountQuantityCard />

                        <CustomerServices />

                        <FeaturesCard />

                        <VideoCourseCard />
                    </Col>
                </Row>
            </div>

            {showJdNps ? (
                <shop-common-components
                    type="NPS"
                    custom-params={JSON.stringify(globalStore.JdSDKStore.npsCustomParams)}
                />
            ) : null}
        </div>
    );
});

export default Home;
